export const socials = {
  // facebook: "facebook",
  // instagram: "instagram",
  youtube: 'youtube',
  vkontakte: 'vk',
  tiktok: 'tiktok',
  twitter: 'twitter',
  rutube: 'rutube',
  max: 'max'
}
